import React, { Component } from 'react';
import { numberWithCommas } from './numberWithCommas';

class CashFormatter extends Component {
  render() {
    const { value } = this.props;
    return <span>{ (value !== null && !isNaN(value) && `$${numberWithCommas(value)}`) }</span>;
  }
}

export default CashFormatter;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/cashFormatter.jsx